var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.844 2.28936L13.7107 0.156002C13.5027 -0.0520007 13.1646 -0.0520007 12.9566 0.156002L5.49028 7.62276C5.43162 7.68143 5.38789 7.7529 5.36176 7.8313L4.29514 11.0313C4.20181 11.3108 4.35327 11.6127 4.63272 11.706C4.68712 11.7241 4.74365 11.7332 4.80071 11.7332C4.85778 11.7332 4.91484 11.7236 4.96924 11.7055L8.1691 10.6388C8.2475 10.6127 8.31897 10.5689 8.37763 10.5103L15.844 3.0435C16.052 2.83497 16.052 2.49736 15.844 2.28936Z",
    fill: "#080A54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7328 15.9999H2.13324C0.956759 15.9999 0 15.0431 0 13.8665V4.26642C0 3.08987 0.956759 2.13306 2.13324 2.13306H6.39973C6.69465 2.13306 6.93304 2.37199 6.93304 2.6664C6.93304 2.9608 6.69465 3.19974 6.39973 3.19974H2.13324C1.545 3.19974 1.06662 3.67814 1.06662 4.26642V13.8665C1.06662 14.4548 1.545 14.9332 2.13324 14.9332H11.7328C12.3211 14.9332 12.7995 14.4548 12.7995 13.8665V9.59982C12.7995 9.30541 13.0378 9.06648 13.3328 9.06648C13.6277 9.06648 13.8661 9.30541 13.8661 9.59982V13.8665C13.8661 15.0431 12.9093 15.9999 11.7328 15.9999Z",
    fill: "#080A54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.85eb9da53d94bd23a109158f6e9ca31a.svg";
export { ForwardRef as ReactComponent };